// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602111303/js/" + chunkId + "." + {"44":"6de4556a","225":"940fd840","481":"d93bfce7","486":"0549ab87","770":"60e1b74d"}[chunkId] + ".0.9251537731661119.chunk.js";
};